export const API_URL = process.env.VUE_APP_API_URL || 'https://docinway.com.mx/api/v1';
export const BASE_URL = process.env.VUE_APP_API_URL || 'https://docinway.com.mx';
export const APP_OP_MEN = process.env.VUE_APP_OP_MEN;
export const APP_OP_KEY = process.env.VUE_APP_OP_KEY;
export const ENV = process.env.NODE_ENV;
